import { Button, Input, Text, Stack, Box } from '@sixfold/common-ui';
import { BackofficeScope } from '@sixfold/session-interface';
import React, { useRef } from 'react';
import { useNavigate, useParams } from 'react-router';

import { useHasScopes, useIsAdmin } from '../../lib/authorization';
import { Routes } from '../../routes';
import { UserInCompany } from '../entities';

export interface UserInCompanyActionBarProps {
  data: {
    usersInCompany: UserInCompany[] | null;
    totalRegularUsersCount: number;
    totalAdminUsersCount: number;
  };
}

type Props = UserInCompanyActionBarProps & {
  company: {
    company_id: string;
  };
  userSearchInput: string;
  setUserSearchInput: (value: string) => void;
  onSearch: () => void;
};

export const UserInCompanyActionBar: React.FC<Props> = ({ data, company, userSearchInput, setUserSearchInput }) => {
  const navigate = useNavigate();
  const { slug_company_name } = useParams<{ slug_company_name?: string }>();
  const { totalRegularUsersCount, totalAdminUsersCount } = data;
  const isAdmin = useIsAdmin();
  const hasCompanyUserEditPermission = useHasScopes([BackofficeScope.companyWriteUsers]);
  const inputWrapperRef = useRef<HTMLDivElement>(null);

  const totalUsersCount = totalRegularUsersCount + totalAdminUsersCount;
  const totalUsersCountString = totalUsersCount === 1 ? ' user' : ' users';

  return (
    <Box paddingBlock="medium">
      <Stack direction="row" alignItems="center">
        <span style={{ fontSize: '1.71rem', fontWeight: 'bold' }}>Users</span>
        <Text prominence="subtle" size="medium">
          {totalUsersCount}
          {totalUsersCountString}: ({totalRegularUsersCount} regular, {totalAdminUsersCount} admin)
        </Text>
        <div ref={inputWrapperRef} style={{ width: 250 }}>
          <Input
            label="Search users"
            labelPosition="hidden"
            name="userSearch"
            size="medium"
            value={userSearchInput}
            onChange={(event) => {
              setUserSearchInput(event.value);
            }}
            placeholder="Search users..."
          />
        </div>
        {(isAdmin || hasCompanyUserEditPermission) && (
          <Button
            onClick={() =>
              void navigate(
                Routes.CompanyUserCreate.generatePath({ company_id: company.company_id, slug_company_name }),
              )
            }
            kind="primary"
            size="medium">
            Add User To Company
          </Button>
        )}
      </Stack>
    </Box>
  );
};
